import { render, staticRenderFns } from "./paymentInfo.vue?vue&type=template&id=880142bc&scoped=true&"
import script from "./paymentInfo.vue?vue&type=script&lang=js&"
export * from "./paymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./paymentInfo.vue?vue&type=style&index=0&id=880142bc&prod&scoped=true&lang=css&"
import style1 from "./paymentInfo.vue?vue&type=style&index=1&id=880142bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880142bc",
  null
  
)

export default component.exports